import { lazy } from "react";

const Checkout = lazy(() => import("./checkout/Checkout"));

export { Checkout };
